var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rowData.dropdown_lists),function(item,index){return _c('span',{staticClass:"text-capitalize badge badge-pill badge-secondary ml-2"},[_vm._v("\n        "+_vm._s(item.list_name)+" "),(item.list_name.length > 1 && index !== _vm.rowData.dropdown_lists.length - 1)?_c('span'):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }